import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { TooltipMenu, Icon, Button, translate } from '@haldor/ui';
import { Skeleton } from 'UI';
import { Search as SearchInput } from 'UI/Inputs';
import { onRouteBack } from 'actions/header';

var Header = /*#__PURE__*/function (_Component) {
  _inherits(Header, _Component);

  var _super = _createSuper(Header);

  function Header() {
    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "goBack", function (event) {
      event.preventDefault();

      if (_this.props.settings.history.length > 1) {
        var newRoute = _this.props.settings.history[1];

        _this.props.onRouteBack();

        _this.props.history.push(newRoute);
      } else {
        window.history.go(-1);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (search) {
      _this.props.history.push('/search?q=' + search.query);
    });

    _defineProperty(_assertThisInitialized(_this), "renderAction", function (action, index) {
      switch (action.type) {
        case 'button':
          return /*#__PURE__*/React.createElement(Button, {
            key: 'action-' + index,
            type: action.buttonType,
            disabled: action.disabled,
            onClick: action.onClick
          }, action.value);

        case 'dropDown':
          return /*#__PURE__*/React.createElement(TooltipMenu, {
            key: 'action-' + index,
            trigger: /*#__PURE__*/React.createElement(Button, {
              disabled: action.disabled
            }, action.icon != null ? /*#__PURE__*/React.createElement(Icon, {
              name: action.icon
            }) : null, action.value)
          }, action.subButtons ? action.subButtons.map(function (subAction, index) {
            return /*#__PURE__*/React.createElement(TooltipMenu.Item, {
              onClick: function onClick() {
                return subAction.onClick(true);
              },
              key: 'subAction-' + index
            }, subAction.value);
          }) : null);

        case 'icon':
          return /*#__PURE__*/React.createElement(Link, {
            to: "#",
            key: 'action-' + index,
            className: "header-action",
            "data-tooltip": action.tooltip,
            onClick: action.onClick
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Cog"
          }));

        default:
          return null;
      }
    });

    return _this;
  }

  _createClass(Header, [{
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "teams-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, this.props.settings.backButton ? /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: this.goBack,
        className: "c--button back"
      }, /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          transform: 'rotate(90deg)'
        },
        className: "a-90"
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })))) : null, this.props.title != null ? /*#__PURE__*/React.createElement("div", {
        className: "page-title",
        title: this.props.title
      }, this.props.title) : /*#__PURE__*/React.createElement("div", {
        className: "page-title",
        style: {
          width: '50%'
        }
      }, /*#__PURE__*/React.createElement(Skeleton, {
        style: {
          width: '75%',
          height: '1.25rem'
        }
      }))), this.isIframe() ? /*#__PURE__*/React.createElement("div", {
        className: "content right"
      }, /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement(SearchInput, {
        placeholder: translate('search') + '...',
        onSubmit: this.onSearch,
        clearOnSubmit: true,
        lengthLimit: 3
      }), this.props.settings.actions != null ? this.props.settings.actions.map(this.renderAction) : null)) : null));
    }
  }]);

  return Header;
}(Component);

function mapStateToProps(state) {
  return {
    title: state.Header.title,
    settings: state.Header,
    translate: translate(state.Languages.translations)
  };
}

export default withRouter(connect(mapStateToProps, {
  onRouteBack: onRouteBack
})(Header));